import { THEME_ENUM } from '@/constants/theme.constant'
import type { Theme } from '@/@types/theme'

/**
 * Since some configurations need to be match with specific themes,
 * we recommend to use the configuration that generated from demo.
 */
export const themeConfig: Theme = {
    themeSchema: '',
    direction: THEME_ENUM.DIR_LTR,
    mode: THEME_ENUM.MODE_LIGHT,
    panelExpand: false,
    controlSize: 'md',
    layout: {
        type: 'collapsibleNotSide',
        sideNavCollapse: false,
    },
}

export const protectedRoutes = {
    '/second': {
        key: 'second',
        meta: {
            layout: 'CollapsibleNotSide',
        },
    },
}
